import * as navigationActions from '../actions/NavigationActions';
import {INavigationModel} from '../models/INavigationModel';
import * as NavigationActions from '../actions/NavigationActions';
import {AppState} from './index';
import {createReducer, on} from '@ngrx/store';

const initialState: INavigationModel = {
  leftNavigationOpen: false,
  rightNavigationOpen: true
};

export const reducer = createReducer(
  initialState,
  on(NavigationActions.leftNavigationCloseAction, state => ({
    ...state,
    leftNavigationOpen: false
  })),
  on(NavigationActions.leftNavigationUpdateAction, state => ({
    ...state,
    leftNavigationOpen: !state.leftNavigationOpen
  })),
  on(NavigationActions.rightNavigationCloseAction, state => ({
    ...state,
    rightNavigationOpen: false
  })),
  on(NavigationActions.rightNavigationUpdateAction, state => ({
    ...state,
    rightNavigationOpen: !state.rightNavigationOpen
  }))
);

/*
export function reducer(state: INavigationModel = initialState, action: NavigationActions.Actions) {
  switch (action.type) {
    case NavigationActions.LEFT_NAVIGATION_UPDATE:
      state.leftNavigationOpen = !state.leftNavigationOpen;
      return state;
    case navigationActions.RIGHT_NAVIGATION_UPDATE:
      state.rightNavigationOpen = !state.rightNavigationOpen;
      return state;
    case navigationActions.RIGHT_NAVIGATION_CLOSE:
      state.rightNavigationOpen = false;
      return state;
    case navigationActions.LEFT_NAVIGATION_CLOSE:
      state.leftNavigationOpen = false;
      return state;
    default:
      return state;
  }
}*/

export const getLeftNavOpen = (state: AppState) => state.navigation.leftNavigationOpen;
export const getRightNavOpen = (state: AppState) => state.navigation.rightNavigationOpen;

